// insulin precision is measured in milli-units but we show microunits to the user
export function insulinPrecisionToUnits(precision: number) {
  return precision / 1000
}
